import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"
import advancedFormat from "dayjs/plugin/advancedFormat"

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(advancedFormat)

/**
 * Format a Unix timestamp (milliseconds) in a target IANA timezone.
 *
 * Fixed output format: `MMM D, YYYY h:mm A z`
 * Example output: `Jul 28, 2026 10:33 AM EDT`
 */
export const formatUnixMillisecondsInTimezone = (
    unixMilliseconds: number,
    timezoneIana: string
): string => {
    const SHORT_TIMEZONE_DATE_TIME_FORMAT = "MMM D, YYYY h:mm A z"
    return dayjs(unixMilliseconds)
        .tz(timezoneIana)
        .format(SHORT_TIMEZONE_DATE_TIME_FORMAT)
}

export default dayjs
